import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { MatchContactFilter } from 'src/app/models/match-contact-filter.model';
import { environment } from 'src/environments/environment';
import { Assignee } from 'src/app/models/assignees/assignee.model';
import { MatchContactItem } from 'src/app/models/match-contact-item.model';
import { IContactService } from '../../interfaces/contact-service.interface';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';

@Injectable({
	providedIn: 'root'
})
export class AssigneeService implements IContactService<Assignee> {

	private baseAssigneeUrl = `${environment.baseUrl}/assignee`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getContacts(token: string): Observable<Assignee[]> {
		return this.httpClient.get<Assignee[]>(`${this.baseAssigneeUrl}/${token}`);
	}

	@ApiMethod()
	createContact(token: string, assignee: Assignee): Observable<number> {
		return this.httpClient.post<number>(`${this.baseAssigneeUrl}/${token}`, assignee);
	}

	@ApiMethod()
	updateContact(token: string, assignee: Assignee): Observable<boolean> {
		return this.httpClient.put<boolean>(`${this.baseAssigneeUrl}/${token}`, assignee);
	}

	@ApiMethod()
	deleteContact(token: string, assigneeId: number): Observable<boolean> {
		return this.httpClient.delete<boolean>(`${this.baseAssigneeUrl}/${token}/${assigneeId}`);
	}

	@ApiMethod()
	getMatchingContacts(token: string, filter: MatchContactFilter): Observable<MatchContactItem[]> {
		return this.httpClient.post<MatchContactItem[]>(`${this.baseAssigneeUrl}/${token}/try-match`, filter);
	}

	@ApiMethod()
	applyToSite(token: string, refId: number): Observable<Assignee> {
		return this.httpClient.get<Assignee>(`${this.baseAssigneeUrl}/${token}/apply-to-site/${refId}`);
	}

	@ApiMethod()
	replaceContact(token: string, assigneeId, replacementRefId: number): Observable<Assignee> {
		return this.httpClient.get<Assignee>(`${this.baseAssigneeUrl}/${token}/replace/${assigneeId}/${replacementRefId}`);
	}
}
